// Sartoria by Sette — marquee drag with seamless resume from drop position
(function() {
  function init() {
    var marquee = document.getElementById('sartoriaMarquee')
                  || document.querySelector('.sartoria .marquee');
    var track = document.getElementById('sartoriaMarqueeTrack')
                || document.querySelector('.sartoria .marquee-track');

    if (!marquee || !track) {
      console.log('[sartoria] marquee elements not found');
      return;
    }
    console.log('[sartoria] drag initialized on', marquee);

    // Read animation duration from CSS (e.g. "50s" -> 50000 ms)
    var animDurationMs = 50000;
    var cs = window.getComputedStyle(track);
    var d = cs.animationDuration;
    if (d) {
      var match = d.match(/^([\d.]+)(s|ms)?/);
      if (match) {
        animDurationMs = parseFloat(match[1]) * (match[2] === 'ms' ? 1 : 1000);
      }
    }

    var isDown = false;
    var startX = 0;
    var startOffset = 0;
    var lastX = 0;
    var velocity = 0;
    var didDrag = false;
    var inertiaRAF = null;
    var halfWidth = 0;

    function measureLoopWidth() {
      halfWidth = track.scrollWidth / 2;
    }

    function getCurrentOffset() {
      var m = window.getComputedStyle(track).transform;
      if (m && m !== 'none') {
        var parts = m.match(/matrix\(([^)]+)\)/);
        if (parts) {
          var vals = parts[1].split(',').map(parseFloat);
          return vals[4] || 0;
        }
      }
      return 0;
    }

    function wrapOffset(px) {
      if (halfWidth <= 0) return px;
      var wrapped = px % halfWidth;
      if (wrapped > 0) wrapped -= halfWidth;
      return wrapped;
    }

    function applyOffset(px) {
      // Hold the track at this px position, override the animation entirely
      track.style.setProperty('transform', 'translateX(' + px + 'px)', 'important');
      track.style.setProperty('animation', 'none', 'important');
    }

    function resumeFromOffset(px) {
      // The CSS animation goes from translateX(0) to translateX(-halfWidth) over animDurationMs.
      // If we want the animation to look like it's currently at "px" (where px is in range (-halfWidth, 0]),
      // we set a negative animation-delay equal to the progress already "elapsed".
      // progress fraction = -px / halfWidth (since px is negative)
      // elapsed time = progress * animDurationMs
      // animation-delay = -elapsed (negative means "start as if it had been running for that long")
      if (halfWidth <= 0) {
        track.style.removeProperty('transform');
        track.style.removeProperty('animation');
        track.style.removeProperty('animation-delay');
        return;
      }
      var wrapped = wrapOffset(px); // ensure in (-halfWidth, 0]
      var progress = -wrapped / halfWidth; // 0..1
      var elapsedMs = progress * animDurationMs;

      // Remove the transform override AND restart the animation from the right point
      track.style.removeProperty('transform');
      track.style.setProperty('animation', 'sartoria-marquee ' + (animDurationMs / 1000) + 's linear infinite', 'important');
      track.style.setProperty('animation-delay', '-' + elapsedMs + 'ms', 'important');
    }

    function onDown(e) {
      isDown = true;
      didDrag = false;
      marquee.classList.add('is-dragging');
      var x = e.pageX || (e.touches && e.touches[0].pageX) || 0;
      startX = x;
      lastX = x;
      velocity = 0;
      if (halfWidth <= 0) measureLoopWidth();
      startOffset = getCurrentOffset();
      applyOffset(startOffset);
      if (inertiaRAF) { cancelAnimationFrame(inertiaRAF); inertiaRAF = null; }
    }

    function onMove(e) {
      if (!isDown) return;
      var x = e.pageX || (e.touches && e.touches[0].pageX) || 0;
      var walk = x - startX;
      if (Math.abs(walk) > 3) didDrag = true;
      velocity = x - lastX;
      lastX = x;
      var newOffset = wrapOffset(startOffset + walk);
      applyOffset(newOffset);
      if (e.cancelable && didDrag) e.preventDefault();
    }

    function onUp() {
      if (!isDown) return;
      isDown = false;
      marquee.classList.remove('is-dragging');

      var currentOffset = getCurrentOffset();

      function inertia() {
        if (Math.abs(velocity) < 0.4) {
          inertiaRAF = null;
          // Immediately resume from current position, no delay
          resumeFromOffset(currentOffset);
          return;
        }
        currentOffset = wrapOffset(currentOffset + velocity);
        applyOffset(currentOffset);
        velocity *= 0.93;
        inertiaRAF = requestAnimationFrame(inertia);
      }
      if (Math.abs(velocity) > 1) {
        inertia();
      } else {
        // No significant velocity, resume immediately from drop position
        resumeFromOffset(currentOffset);
      }
    }

    marquee.addEventListener('mousedown', onDown);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);

    marquee.addEventListener('touchstart', onDown, { passive: true });
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onUp);
    document.addEventListener('touchcancel', onUp);

    marquee.addEventListener('dragstart', function(e) { e.preventDefault(); });
    marquee.addEventListener('click', function(e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    var imgs = track.querySelectorAll('img');
    var loaded = 0;
    var total = imgs.length;
    function check() {
      loaded++;
      if (loaded >= total) measureLoopWidth();
    }
    if (total === 0) {
      measureLoopWidth();
    } else {
      imgs.forEach(function(img) {
        if (img.complete) check();
        else {
          img.addEventListener('load', check);
          img.addEventListener('error', check);
        }
      });
      setTimeout(measureLoopWidth, 2000);
    }
    window.addEventListener('resize', measureLoopWidth);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();